import React, { useRef } from 'react';
import useClickableMentions from 'ui/elements/form/RichTextEditor/useClickableMentions';
import UserProfileDialog from 'domain/users/UserProfile/UserProfileDialog';
import PublicProfileDialog from 'domain/companies/ProfileDialog/ProfileDialog';
import HtmlContent from 'ui/elements/HtmlContent';
import { useIframeHeights } from 'hooks/useIframeHeights';
import { UpdateEmbed, useHydrateUpdateBlots } from 'ui/elements/form/RichTextEditor/components/UpdateBlot';
import { KpiEmbedCard, useHydrateKpiBlots } from 'ui/elements/form/RichTextEditor/components/KpiBlot';
import { createPortal } from 'react-dom';

interface Props {
  className?: string;
  style?: object;
  children: string;
  onClick?: () => void;
}

export default function HtmlContentWithMentions({ className, style, children, onClick }: Props) {
  const contentRef = useRef<HTMLParagraphElement>(null);
  const embeddedUpdateMounts = useHydrateUpdateBlots(contentRef);
  const embeddedKpiMounts = useHydrateKpiBlots(contentRef);

  const { userProfileIdToShow, setUserProfileIdToShow, companyProfileIdToShow, setCompanyProfileIdToShow } =
    useClickableMentions(contentRef);
  useIframeHeights(contentRef);

  return (
    <>
      <HtmlContent ref={contentRef} embeddingIsAllowed onClick={onClick} style={style} className={className}>
        {children}
      </HtmlContent>
      {/* Hydrate updates */}
      {embeddedUpdateMounts
        .filter(m => m.updateId && m.slug && m.type)
        .map(m =>
          createPortal(<UpdateEmbed key={m.updateId} updateId={m.updateId} slug={m.slug} type={m.type} />, m.node),
        )}
      {/* Hydrate KPI embeds */}
      {embeddedKpiMounts.map(m => createPortal(<KpiEmbedCard key={m.embed.id} embed={m.embed} />, m.node))}
      {userProfileIdToShow && (
        <UserProfileDialog cwUserId={userProfileIdToShow} onClose={() => setUserProfileIdToShow(undefined)} />
      )}
      {companyProfileIdToShow && (
        <PublicProfileDialog companyId={companyProfileIdToShow} onClose={() => setCompanyProfileIdToShow(undefined)} />
      )}
    </>
  );
}
